import React from "react";
import { safeMutate } from "../../../utils/GeneralUtils";
import ChrPercentage from "../../generic/PageUI/Basic/ChrPercentage";
import { getFormattedNumber } from "../../generic/PageUI/Basic/Metric/utils";
import { WidgetUId } from "../Widgets/constants";
import { MetricUId } from "./constants";

export const getMetricDataFromArray = (metrics, metricUId) => {
  return metrics.find((metric) => metric.uId === metricUId);
};

export const getMetricsDataFromArray = (metrics, metricUIds) => {
  return metrics.filter((metric) => metricUIds.includes(metric.uId));
};

export const getFormattedRate = (rate, options) => {
  const newRate = safeMutate(rate, draftRate => {
    draftRate.data.value = <ChrPercentage value={rate.data.value} />;
    draftRate.subMetrics = rate.subMetrics.map((subMetric) => {
      return {
        ...subMetric,
        data: {
          value: `${subMetric.data[options.numeratorExtractorKey]} / ${subMetric.data.total}`,
          formattedValue: `${getFormattedNumber(subMetric.data[options.numeratorExtractorKey]).valueToDisplay} / ${getFormattedNumber(subMetric.data.total).valueToDisplay}`
        }
      }
    });
  })

  return newRate;
};

export const widgetUIdToMetricUIdMap = {
  [WidgetUId.ONGOING_MEETING_RATING_STATS]: MetricUId.ONGOING_MEETING_RATING_RESPONSES,
  [WidgetUId.ONE_TIME_MEETING_RATING_STATS]: MetricUId.ONE_TIME_MEETING_RATING_RESPONSES,
  [WidgetUId.ONGOING_GOOD_MEETING_RATING_REASONS]: MetricUId.ONGOING_GOOD_MEETING_RATING_REASONS,
  [WidgetUId.ONE_TIME_GOOD_MEETING_RATING_REASONS]: MetricUId.ONE_TIME_GOOD_MEETING_RATING_REASONS,
  [WidgetUId.ONGOING_BAD_MEETING_RATING_REASONS]: MetricUId.ONGOING_BAD_MEETING_RATING_REASONS,
  [WidgetUId.ONE_TIME_BAD_MEETING_RATING_REASONS]: MetricUId.ONE_TIME_BAD_MEETING_RATING_REASONS
};